import { FieldError } from 'react-hook-form/dist/types';

export type Join<K, P> = K extends string | number
  ? P extends string | number
    ? `${K}${'' extends P ? '' : '.'}${P}`
    : never
  : never;

export type Prev = [
  never,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  ...0[],
];

export type Paths<T, D extends number = 10> = [D] extends [never]
  ? never
  : T extends object
    ? {
        [K in keyof T]-?: K extends string | number
          ? `${K}` | Join<K, Paths<T[K], Prev[D]>>
          : never;
      }[keyof T]
    : '';

export function getError(errors: any, path: string): FieldError | undefined {
  const parts = path.split('.');
  let current = errors;
  let result = undefined;
  parts.forEach((part) => {
    if (current && part in current) {
      current = current[part];
      result = current;
    } else {
      result = undefined;
    }
  });
  if (result) {
    return result as FieldError;
  }
  return undefined;
}

export function deleteError(errors: any, path: string): void {
  delete errors[path];
}

export function findFirstErrorMessage(errors: unknown): string | undefined {
  if (!errors || typeof errors !== 'object') {
    return undefined;
  }
  for (const key of Object.keys(errors)) {
    const err = (errors as Record<string, unknown>)[key];
    if (!err) {
      continue;
    }
    if (
      typeof err === 'object' &&
      err !== null &&
      'message' in err &&
      typeof (err as { message?: unknown }).message === 'string'
    ) {
      return (err as { message: string }).message;
    }
    if (typeof err === 'object') {
      const nested = findFirstErrorMessage(err);
      if (nested) {
        return nested;
      }
    }
  }
  return undefined;
}
